export default __webpack_public_path__ + "static/ArduinoNanoScrewTerminal-ca8128738900502a1b5c49c26f26d30c.svg";